import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { readyPercentage } from '../readinessSections';
// Green at 100%, orange from 90%, red below.
const ReadinessRing = ({ stats }) => {
    const percentage = stats.total === 0 ? 0 : readyPercentage(stats);
    const state = (() => {
        if (stats.total === 0)
            return 'none';
        if (stats.issues === 0)
            return 'ok';
        return percentage >= 90 ? 'warn' : 'bad';
    })();
    return (_jsx("div", Object.assign({ className: classNames('readiness-ring', state), style: { '--percentage': percentage } }, { children: _jsx("span", { children: stats.total === 0 ? '—' : `${percentage}%` }) })));
};
export default ReadinessRing;
